import { useContext, useEffect, useState } from 'react';

import { sendAdminState } from '@/action/server_action';
import { FieldRenderer } from '@/components/game/ui/modal/FieldRenderer';
import { GameContext } from '@/state/contexts';
import { logg } from '@/util/logg';
import { GameStateSchema } from '@lc/schema/GameStateSchema';
import '@/style/HandModal.css';

const AdminStateModal = ({ onClose }) => {
	const {
		currPlayer,
		gameState,
		singlePlayer,
		performAdminStateUpdate,
	}: any = useContext(GameContext);
	const [modalGameState, setModalGameState] = useState<any>(null);

	useEffect(() => {
		if (gameState) {
			setModalGameState(structuredClone(gameState));
		}
	}, [gameState]);

	function sendAdminStateBtn() {
		logg('attempting to update admin state');
		logg('single player? ' + singlePlayer);
		if (singlePlayer) {
			performAdminStateUpdate(currPlayer, modalGameState);
		} else {
			sendAdminState(currPlayer, modalGameState);
		}
	}

	if (!modalGameState) return;

	return (
		<div className="modal" onClick={onClose}>
			<div className="modal-content" onClick={(e) => e.stopPropagation()}>
				<span className="close" onClick={onClose}>
					&times;
				</span>

				<div
					className="admin-panel"
					style={{ maxHeight: '70vh', overflowY: 'auto' }}
				>
					{modalGameState && (
						<FieldRenderer
							schema={GameStateSchema}
							value={modalGameState}
							onChange={setModalGameState}
						/>
					)}
				</div>

				<button onClick={sendAdminStateBtn}>Update State</button>
			</div>
		</div>
	);
};

export default AdminStateModal;
